export default function CerrarSesion(){
    return (
        <>
            <div className="d-flex justify-content-center py-2">
                <div className="list-group-item">
                    <button onClick={limpiarAlmacenamiento} className="btn btn-danger">Cerrar sesión</button>
                </div>
            </div>
        </>
       );
}

function limpiarAlmacenamiento(){
    localStorage.clear();
    window.location.href='/';
}